import { icons } from "../../../../utils/icons";
import { useEffect, useState } from "react";
import { differenceInSeconds, format } from "date-fns";

interface ClienteCardProps {
  nome: string;
  cpf?: string;
  status?: number;
  isSelected?: boolean;
  text?: string;
  hora_ini_atendimento?: string;
  hora_atribuicao?: string;
  hora_fila: string;
  naoLido?: number;
  icon?:
  | "whatsapp"
  | "sms"
  | "chatbot"
  | "email"
  | "portal"
  | "ligacao"
  | "agenteVirtual"
  | "webchat";
}

export const ClienteCard = ({
  nome,
  isSelected,
  hora_fila,
  naoLido
}: ClienteCardProps) => {

  return (
    <>
      <div

        className={` min-w-md my-1 flex h-16 items-center justify-between z-0 rounded-md  select-none bg-gray-100 p-1 ${isSelected && "border-2 border-primary"
          } `}
      >
        <div className="flex items-center  ">
          <div className="ml-1 text-gray-800  max-w-[180px] min-w-[180px]  ">
            <p className="text-[0.55rem] max-w-[90%] truncate overflow-hidden text-ellipsis font-bold">{nome}</p>
            {/* <p className="mt-1 text-[0.6rem] underline">{cpf}</p> */}
          </div>
        </div>
        <div
          className={` flex flex-col  items-end  `}
        >
          <div className=" flex items-center justify-end ">
            <p className="mr-2 text-xs text-gray-600 whitespace-nowrap"></p>
            {/* <Tooltip content={iconName} placement="bottom-end"> */}
            <p className="mr-2 text-xs text-gray-600 whitespace-nowrap">{hora_fila && format(new Date(hora_fila), 'dd/MM HH:mm')}</p>
            <div className={`flex h-5 w-5 items-center justify-center rounded-full bg-primary ${naoLido && naoLido > 0 ? 'bg-red-600' : 'bg-primary'}`}>

              {
                naoLido && naoLido > 0 ? (
                  <p className="text-white text-sm">{naoLido}</p>
                ) : (
                  <img
                    src={icons['whatsapp'].icons}
                    alt=""
                    className="relative h-4 w-4"
                  />
                )
              }


            </div>
            {/* </Tooltip> */}
          </div>
          <div
            className={`mt-2 w-full rounded-sm text-center bg-yellow-icons`}
          //  ${!isMoreThan24 ? 'bg-yellow-icons' : status === 3 ? 'bg-gray-400' : 'bg-error'} 
          >

            <p className="m-0.5 text-[0.6rem] font-light text-white whitespace-nowrap">Transbordo</p>
          </div>
        </div>
      </div>
    </>
  );
};